<template>
  <ul class="messages_list">
    <li v-for="(item,i) in messagesList" :key="item.id">
      <van-image round width="40px" height="40px" :src="
          item.memberResourceUrl
            ? item.memberResourceUrl
            : require('@/assets/images/user_default.png')
        " />
      <div class="messages_content">
        <div class="messages_info">
          <p>{{ item.memberNickname }}</p>
          <span>{{ item.createdTime }}</span>
        </div>
        <div class="messages_text">
          <p>{{ item.leaveWord }}</p>
        </div>
        <div class="btn" v-if="!!userInfo && item.allowDelete">
          <p>{{ item.publishStatus == 0 ? "未发布" : "已发布" }}</p>
          <span @click="delHandler(item,i)">删除</span>
        </div>
        <div class="reply" v-if="item.reply">
          <van-image round fit="cover" width="24px" height="24px" :src="item.lconResourceUrl" />
          <p><span>号主回复：</span>{{ item.reply }}</p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";
import { deepClone } from "@/utils";
import mediaApi from "@/api/apis/media.js";
export default {
  name: "MessagesList",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  props: {
    contentList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      messagesList: [],
    };
  },
  watch: {
    contentList: {
      handler(newVal, oldVal) {
        this.messagesList = deepClone(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    delHandler(item, i) {
      mediaApi
        .deleteSelfMediaMessages({
          ids: item.id,
        })
        .then((res) => {
          if (res.suc == 1) {
            this.$dialog
              .alert({
                message: "删除成功！",
              })
              .then(() => {
                this.$emit("deleteItem",i);
              });
          } else {
            this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    this.messagesList = deepClone(this.contentList);
  },
};
</script>
<style lang="scss" scoped>
.messages_list {
  li {
    padding-top: 20px;

    display: flex;
  }
  .messages_content {
    flex: 1;
    margin-left: 7px;
    padding-bottom: 13px;
    border-bottom: 1px solid #e1e1e1;
    .messages_info {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 8px;
      p {
        color: #040405;
      }
      span {
        color: #a8a8a8;
      }
    }
    .messages_text {
      line-height: 20px;
      p {
        background-color: #fff;
        padding: 9px 12px 11px 17px;
        border-radius: 15px;
        display: inline-block;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          left: -7px;
          top: 12px;
          width: 0;
          height: 0;
          border-top: 8px solid #fff;
          border-left: 8px solid transparent;
        }
      }
    }
    .btn {
      display: flex;
      justify-content: flex-end;
      font-size: 15px;
      line-height: 20px;
      margin-top: 8px;
      p {
        color: #9f9f9f;
        margin-right: 10px;
      }
      span {
        color: #e02020;
      }
    }
    .reply {
      display: flex;
      margin-top: 13px;
      p {
        margin-left: 7px;
        line-height: 20px;
        span {
          color: #e02020;
        }
      }
      /deep/ .van-image {
        min-width: 24px;
      }
    }
  }
}
</style>